import {
    complementBases,
    wordings,
    basesOperationLabel,
    EDITOR_TYPES,
    SINGLE_NUCLEIC_ACID_TYPES,
    Selector,
} from "../mixins/dictionaries"

import {
    cleanSearchText,
    getBasePairs,
    getSelectedAminoAcids,
    variantPosition,
    fixValidEnd,
    countCharacters,
    getRangeBases,
    getAffectedSlots,
    getBoundsBpArea,
    normalizeBPPosition,
    validInputValueEdges,
    toggleClass,
    thousandSeparator,
    rangeOverlapStart,
    isInsideArea,
    insertableBasePairPosition,
    editorPath,
    annotationPath,
    loadModal
} from "./utils";


import {appendToast} from "../bootstrap"
import * as shortcuts from "../modules/shortcuts";

export default class Overview {
    constructor(initSettings, mediator) {
        this.settings = {
            ...initSettings,
            "id": "toolbar",
        };

        this.mediator = mediator;

        this.initSelectors();

        this.initOverView();

        this.bindEvents();
        this.EventsOn();
    }

    initOverView() {
        this.zoom = 12;
        this.fontHeight = 12;

        this.rangeBp = {
            start: 0,
            end: 0
        };

        this.offsetScroll = {
            "current": 0
        };

        this.edges = {
            left: 0,
            right: 0,
        };

        this.parameters = {
            "start": 0,
            "end": 0
        };

        this.currentValueInputs = {
            'fromBp': 1,
            'toBp': 1,
            'cursorPosition': 1,
        }

        this.areaViewSettings = {
            pos: 0,
            width: 0
        };

        this.selectAll = false;
        this.GCContent = 0;
        this.modalParameters = "";
        this.editorUrl = "";

        this.userAgent = window.navigator.userAgent;
        this.minSequenceLength = 240;
    }

    initDataSequence(data) {
        this.mainData = [{}];
        if (data.hasOwnProperty("slots")) {
            this.rootUrl = data.urls.design;
        } else {
            if (data.urls?.editor) {
                this.rootUrl = data.urls.editor;
                this.mainData[0] = {
                    editable: data.editable,
                    direction: 0,
                    length: data.sequence.length
                }
            } else {
                this.rootUrl = data.urls.view;
            }
        }

        this.srcData = {
            slots: data.slots || null
        };

        this.sequence = data.sequence;
        this.sequenceLength = parseInt(data.sequence.length);
        this.isSingleStranded = SINGLE_NUCLEIC_ACID_TYPES.includes(data.nucleic_acid_type)
    }

    initData(data) {
        this.initDataSequence(data);

        this.initElements();
    }

    initSelectors() {
        this.$modalContainer = document.querySelector(Selector.MODAL);

        this.$mainPanel = document.querySelector(`#${this.settings.id} #mainPanel`);

        this.$tabCursor = this.$mainPanel.querySelector('li:nth-child(1) a');
        this.$tabSearch = this.$mainPanel.querySelector('li:nth-child(2) a');
        this.$tabRange = this.$mainPanel.querySelector('li:nth-child(3) a');

        this.$contentPanel = document.querySelector(`#toolbar #secondaryPanel`);
        /**
         * Go to panel
         * */
        this.$cursorPanel = this.$contentPanel.querySelector("#moveTo");
        this.$baseBpCursor = this.$cursorPanel.querySelector("#cursorPosition");
        this.$goToStart = this.$cursorPanel.querySelector("#goToStart");
        this.$goToButton = this.$cursorPanel.querySelector("#goToBase");
        this.$goToEnd = this.$cursorPanel.querySelector("#goToEnd");

        /**
         * search panel
         * */
        const $searchPanel = this.$contentPanel.querySelector('#search');
        this.$searchForm = $searchPanel.querySelector("form");
        this.$txtToSearch = $searchPanel.querySelector("#txtToSearch");
        this.$elementsFound = $searchPanel.querySelector("#elementsFound");
        this.$goSearchButton = $searchPanel.querySelector("#goSearch");
        this.$moveOnSearchButtons = $searchPanel.querySelectorAll('.moveOnSearch');
        this.$resetSearchButton = $searchPanel.querySelector("#reset");
        this.$searchInSelectionDropDown = $searchPanel.querySelector("#searchInSelect");
        this.$searchInRangeCheckBox = $searchPanel.querySelector(".form-check > input");

        /**
         * Select panel
         * */
        const $rangePanel = this.$contentPanel.querySelector('#range');
        this.$baseBpFrom = $rangePanel.querySelector("#fromBp");
        this.$baseBpTo = $rangePanel.querySelector("#toBp");

        this.$copyButtons = document.querySelectorAll("#toolbar [data-copy-bases]");

        this.$analyzeWithButton = document.querySelector("#toolbar [data-analyze-with]");

        this.$selectAllButton = document.querySelectorAll("#toolbar .select-all");
        this.$reverseSelectionButton = document.querySelectorAll("#toolbar .reverse-selection");

        this.$baseBpInputs = document.querySelectorAll("input#cursorPosition, input#fromBp, input#toBp");

        this.$toolbarButtons = document.querySelectorAll("#toolbar button");
        this.$changeSequenceButtons = document.querySelectorAll("[data-change-sequence]");
        this.$annotateAsButtons = document.querySelectorAll("#toolbar [data-annotate-sequence]");

        this.$changeSlotButtons = document.querySelectorAll("#toolbar .slot[data-editor-url]");

        this.$extractButton = document.querySelector("#toolbar [data-type=extract-sequence]");

        /**
         * Validate panel
         * */
        this.$validationProtocolActive = document.querySelector("#toolbar a[href='#validate'] div.position-absolute");

        /**
         * Slot actions
         * */
        this.$revertOrientationButtons = document.querySelectorAll("button[data-type='revert-orientation'], a[data-type='revert-orientation']");
        this.$toolbarSlot = document.querySelectorAll(".toolbar-slot .dropdown-toggle");

        this.$overviewTools = document.querySelector("#overviewTools");

        this.$zoom = this.$overviewTools.querySelector("#sliderZoom");
        this.$zoomButtons = this.$overviewTools.querySelectorAll("[data-editor-zoom]");

        this.$slider = this.$overviewTools.querySelector("#sliderScroll");
        this.$sliderButtons = this.$overviewTools.querySelectorAll("[data-editor-scroll]");

        this.$summary = document.querySelector('.overview');

        this.baseLength = document.querySelectorAll('.needs-bp-length');

        this.$toastContainer = document.querySelector(Selector.TOASTS);

        if (this.isSingleStranded) {
            this.$copyButtons[1].classList.add("d-none")
        }
    }

    initElements() {
        this.$baseBpCursor.max = this.sequenceLength + 1;
        this.$baseBpFrom.max = this.sequenceLength;
        this.$baseBpTo.max = this.sequenceLength;

        if (this.settings.circular && this.sequenceLength <= this.minSequenceLength) {
            this.zoom = 4;
            this.$zoom.value = 4;
            this.$zoom.setAttribute("disabled", "")
        } else {
            this.$zoom.removeAttribute("disabled");
        }

        if (this.settings.editorType === EDITOR_TYPES.cloningrequest) {
            this.zoom = 4;
        }

        this.$zoom.value = this.zoom;

        this.activePanel = "moveTo";

        /**
         * set validate tab
         * */
        if (this.settings.activeValidate) {
            this.activePanel = "validate";

            this.settings.activeValidate = false;
        }

        if (this.settings.initialPosition && parseInt(this.settings.initialPosition) !== 0) {
            const initPosition = parseInt(this.settings.initialPosition);
            this.$baseBpCursor.value = initPosition + 1;
            this.rangeBp = {
                start: initPosition,
                end: initPosition
            }

            this.settings.initialPosition = 0;
        }

        this.$baseBpCursor.value = Math.round(this.rangeBp.start + 1);
        this.$baseBpFrom.value = Math.round(this.rangeBp.start + 1);
        this.$baseBpTo.value = Math.round(this.rangeBp.end + 1);

        this.setPanel();
        this.printSummary();

        this.slotsAffectedByRange(this.rangeBp.start, this.rangeBp.end);
        this.resetSearch();
    }

    setData(data) {
        if (data.sequence) {
            this.initData(data);
        }
    }

    updateAnnotations(data) {
        if (this.$validationProtocolActive) {
            if (data.annotations.length) {
                this.$validationProtocolActive.classList.remove("d-none")
            } else {
                this.$validationProtocolActive.classList.add("d-none")
            }
        }
    }

    setAreaView(data) {
        this.maxBasePairsInAreaView = data.width;
        this.offsetScroll.current = data.position;

        if (this.settings.circular) {
            this.$slider.max = this.sequenceLength;
            this.edges.left = this.offsetScroll.current - Math.round(this.maxBasePairsInAreaView / 2)
            this.edges.right = this.edges.left + this.maxBasePairsInAreaView;

            if (this.edges.left < 0) {
                this.edges.left += this.sequenceLength;
            }
            if (this.edges.right > this.sequenceLength) {
                this.edges.right -= this.sequenceLength;
            }
        } else {
            this.$slider.max = this.sequenceLength - data.width;
            this.edges.left = this.offsetScroll.current;
            this.edges.right = this.edges.left + this.maxBasePairsInAreaView;

            if (this.edges.right > this.sequenceLength) {

                this.edges.left = this.sequenceLength - this.maxBasePairsInAreaView;
                this.edges.right = this.sequenceLength;
                this.offsetScroll.current = this.edges.left;
            }
        }
        this.$slider.value = this.offsetScroll.current;
    }

    printSummary() {
        let listBody = `
            <div>
                Total bases: <strong class="needs-bp-length">${thousandSeparator(this.sequenceLength)}</strong>
            </div>
        `;

        if (this.activePanel === "range") {
            const fromBp = parseInt(this.$baseBpFrom.value);
            const toBp = parseInt(this.$baseBpTo.value);
            let realToBp = fixValidEnd(fromBp, toBp, this.sequenceLength)

            listBody += `
                <div>
                    Selected: <strong class="rangeLength">${thousandSeparator(realToBp - fromBp + 1)}</strong> bp 
                </div> 
                <div>
                    From <strong class="rangeFrom">${thousandSeparator(fromBp)}</strong> to <strong class="rangeTo">${thousandSeparator(toBp)}</strong> 
                </div>
                <div>
                    GC: <strong>${this.GCContent}%</strong>
                </div>               
            `;
        } else {
            listBody += `
                <div>
                    Cursor before bp: <strong class="cursorPosition">${thousandSeparator(this.$baseBpCursor.value)}</strong>
                </li>
            `;
        }
        this.$summary.innerHTML = `<div class="d-flex gap-3 text-body-tertiary">${listBody}</div>`;

        this.baseLength.forEach(label => {
            label.innerHTML = this.sequenceLength + " bp"
        })
    }

    setPanel() {
        this.$mainPanel.querySelectorAll('li.nav-item a').forEach((el) => {
            el.classList.remove('active');
        });

        this.$contentPanel.querySelectorAll('.tab-pane').forEach((el) => {
            el.classList.remove('active');
        });

        const activeTab = this.$mainPanel.querySelector("a.nav-link[href='#" + this.activePanel + "']");
        activeTab.classList.add("active");

        const activeContent = this.$contentPanel.querySelector("#" + this.activePanel + ".tab-pane");
        activeContent.classList.add("active");
    }

    /**
     * set Input values fromBp and toBp
     *
     * @param data {Object} with "start" and "end" parameters - from external components
     * */
    selectRange(data, disableSearchPanel = true) {
        this.rangeBp = {
            start: data.start,
            end: data.end
        };

        let start = Math.round(normalizeBPPosition(data.start, this.sequenceLength));
        let end = Math.round(normalizeBPPosition(data.end, this.sequenceLength));

        let fromBp = start + 1;
        let toBp = end;

        if (Math.round(data.start) === Math.round(data.end)) {
            this.activePanel = "moveTo";
            end += this.settings.circular ? this.sequenceLength : 0;
            toBp += 1;
        } else {
            this.activePanel = "range";
        }

        if (data.start < 0) {
            this.activePanel = "range";
        }

        /**
         * get GCContent
         * */
        this.GCContent = this.getGCContent(start, end);

        /**
         * check which slots are affected by selection
         * */
        this.slotsAffectedByRange(data.start, data.end);

        /**
         * set input values
         * set buttons and hrefs with needAttributes class
         * print summary
         * */
        this.setInputValues(fromBp, toBp);
        this.setNeedParameters(fromBp, toBp, "setOverView");
        this.printSummary();

        if (!disableSearchPanel) {
            this.activePanel = "search";
        }

        this.setPanel();

        /**
         * set scrollerInputRange
         * */
        if (!isInsideArea(start, end, this.edges.left, this.edges.right, this.sequenceLength)) {
            this.setScrollerInputRange(start)
        }
    }

    /**
     * check which slots are affected by selection range
     *
     * @param start {Number} input value for start
     * @param end {Number} input value end
     * */
    slotsAffectedByRange(start, end) {
        if (this.srcData.slots?.length > 0) {
            this.mainData = getAffectedSlots(start, end, this.srcData.slots, this.sequenceLength);
        }

        /**
         * toggle menu slot
         * */
        if (this.srcData.slots && this.srcData.slots.length && this.mainData.length === 1 && (Math.round(end) - Math.round(start)) === this.mainData[0].length) {
            if (this.mainData[0].direction === 0 || this.mainData[0].dna_sequence.public) {
                toggleClass(this.$revertOrientationButtons, "disabled")
            }
            toggleClass(this.$toolbarSlot, "disabled", "remove");
        } else {
            toggleClass(this.$toolbarSlot, "disabled");
        }
    }

    /**
     * Set new values for inputs baseBpCursor, fromBp and toBp
     *
     * @param fromBp {Number} input value for fromBp or baseBpCursor
     * @param toBp {Number} input value toBp
     * */
    setInputValues(fromBp, toBp) {
        this.$baseBpCursor.value = fromBp;
        this.$baseBpFrom.value = fromBp;
        this.$baseBpTo.value = toBp;

        if (fromBp === this.sequenceLength + 1) {
            this.$baseBpFrom.value = fromBp - 1;
        }

        if (toBp === 0) {
            this.$baseBpTo.value = 1;
        }

        this.currentValueInputs = {
            'fromBp': this.$baseBpFrom.value,
            'toBp': this.$baseBpTo.value,
            'cursorPosition': this.$baseBpCursor.value
        };
    }

    /**
     * Set Parameters for button with data-modal-parameters attribute
     *
     * @param fromBp {Number} input value fromBp
     * @param toBp {Number} input value toBp
     * @param callToAction {String} callToAction
     * @return {void}
     */
    setNeedParameters(fromBp, toBp, callToAction, bases = "", direction = "1") {
        this.parameters.start = fromBp;
        if (callToAction !== "insert-bases") {
            this.parameters.end = (toBp <= this.sequenceLength) ? toBp : toBp - this.sequenceLength;
        } else {
            delete this.parameters.end
        }

        if (bases.length) {
            this.parameters.sequence = bases
            this.parameters.direction = direction
        } else {
            delete this.parameters.sequence
            delete this.parameters.direction
        }

        this.modalParameters = this.parameters;

        if (fromBp > toBp) {
            this.$changeSequenceButtons.forEach((button) => {
                button.style.cursor = 'not-allowed'
            })
        } else {
            // otherwise
            this.$changeSequenceButtons.forEach((button) => {
                button.style.cursor = ''
            })
        }
    }

    bindEvents() {
        this.$tabSearch.addEventListener("click", (e) => {
            e.preventDefault();
            this.validationInputError();
            const fromBp = parseInt(this.$baseBpFrom.value);
            const toBp = parseInt(this.$baseBpTo.value);

            this.$searchInRangeCheckBox.checked = false;
            this.$searchInRangeCheckBox.disabled = (fromBp === toBp)
        });

        this.$searchForm.addEventListener("submit", (e) => {
            e.preventDefault();
            this.search(this.$txtToSearch.value);
        });

        this.$goSearchButton.addEventListener("click", (e) => {
            e.preventDefault();
            this.search(this.$txtToSearch.value)
        });

        this.$moveOnSearchButtons.forEach(el => {
            el.addEventListener("click", e => {
                e.preventDefault();

                this.statusSearch.currentPosition += el.id === "right" ? 1 : -1;

                this.moveOnSearch(this.statusSearch.currentPosition);
            });
        })

        this.$resetSearchButton.addEventListener("click", (e) => {
            e.preventDefault();
            this.resetSearch(true)

            this.EventsTrigger("resetSearch")
        });

        this.$searchInSelectionDropDown.addEventListener("change", (e) => {
            const item = e.currentTarget;
            this.setSelectionSearch(item.value)
        });


        this.$tabCursor.addEventListener("click", (e) => {
            e.preventDefault();
            this.validationInputError();

            this.activePanel = "moveTo";

            if (!this.checkBaseNumber("cursorPosition")) {
                this.$baseBpCursor.value = this.currentValueInputs.cursorPosition;
            }

            let fromBp = parseInt(this.$baseBpCursor.value);
            let toBp = parseInt(this.$baseBpCursor.value);

            this.rangeBp = {
                start: fromBp - 1,
                end: fromBp - 1
            }

            this.GCContent = 0;
            this.slotsAffectedByRange(fromBp - 1, toBp - 1);

            this.setInputValues(fromBp, toBp);
            this.setNeedParameters(fromBp, toBp, "selection");
            this.printSummary();

            this.EventsTrigger("selectRange", this.rangeBp);
        });

        this.$tabRange.addEventListener("click", (e) => {
            e.preventDefault();
            this.validationInputError();
            this.activePanel = "range";

            if (!this.checkBaseNumber("selectRange")) {
                this.$baseBpCursor.value = this.currentValueInputs.cursorPosition;
            }

            const fromBp = parseInt(this.$baseBpCursor.value);
            const toBp = parseInt(this.$baseBpCursor.value);

            this.rangeBp = {
                start: fromBp - 1,
                end: toBp
            }

            this.GCContent = this.getGCContent(fromBp - 1, toBp);

            this.slotsAffectedByRange(fromBp - 1, toBp);

            this.setInputValues(fromBp, toBp);
            this.setNeedParameters(fromBp, toBp, "selection");
            this.printSummary();

            this.EventsTrigger("selectRange", this.rangeBp);
        });

        this.$baseBpInputs.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.changeBasePairInput(e)
            })
            el.addEventListener("keyup", (e) => {
                this.changeBasePairInput(e)
            })
            el.addEventListener("keydown", (e) => {
                if (e.code === "Enter") {
                    this.changeBasePairInput(e)
                }
            })
        });

        this.$goToStart.addEventListener("click", () => {
            const currentInputValue = Math.round(this.$baseBpCursor.value)
            const firstInsertableBase = insertableBasePairPosition(currentInputValue - 1, 1, this.srcData.slots) - 0.99;

            const rangeBp = {
                start: firstInsertableBase,
                end: firstInsertableBase
            }
            this.selectRange(rangeBp)

            if (this.sequenceLength > this.maxBasePairsInAreaView && !(this.edges.left <= rangeBp.start && rangeBp.end <= this.edges.right)) {
                const tempOffsetScroll = this.settings.circular ? Math.round(rangeBp.start) : Math.round(rangeBp.start) - Math.round(this.maxBasePairsInAreaView / 2);
                this.setOffsetScroll(tempOffsetScroll);
                this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
                this.EventsTrigger("slide", "end")
            }

            this.EventsTrigger("selectRange", {
                start: Math.round(firstInsertableBase),
                end: Math.round(firstInsertableBase)
            });
        });

        this.$goToEnd.addEventListener("click", () => {
            const currentInputValue = Math.round(this.$baseBpCursor.value);
            const lastInsertableBase = insertableBasePairPosition(currentInputValue, this.sequenceLength + 1, this.srcData.slots) - 1.01

            const rangeBp = {
                start: lastInsertableBase,
                end: lastInsertableBase
            }
            this.selectRange(rangeBp)

            if (this.sequenceLength > this.maxBasePairsInAreaView && !(this.edges.left <= rangeBp.start && rangeBp.end <= this.edges.right)) {
                const tempOffsetScroll = this.settings.circular ? Math.round(rangeBp.start) : Math.round(rangeBp.start) - Math.round(this.maxBasePairsInAreaView / 2);
                this.setOffsetScroll(tempOffsetScroll);
                this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
                this.EventsTrigger("slide", "end")
            }

            this.EventsTrigger("selectRange", {
                start: Math.round(lastInsertableBase),
                end: Math.round(lastInsertableBase)
            });
        });

        this.$goToButton.addEventListener("click", () => {
            if (this.checkBaseNumber("cursorPosition")) {
                const inputValue = parseInt(this.$baseBpCursor.value);

                /**
                 * update cursor if currentValueInputs.cursorPosition !== value input cursor
                 * */
                const rangeBp = {
                    start: inputValue - 1,
                    end: inputValue - 1
                }
                this.selectRange(rangeBp)

                if (!(this.edges.left <= rangeBp.start && rangeBp.end <= this.edges.right)) {
                    const newOffsetScroll = this.settings.circular ? rangeBp.start : rangeBp.start - Math.round(this.maxBasePairsInAreaView / 2);
                    this.setOffsetScroll(newOffsetScroll);
                    this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
                    this.EventsTrigger("slide", "end")
                }

                this.EventsTrigger("selectRange", rangeBp);
            }
        });

        this.$copyButtons.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.copyBasePairs(e.currentTarget.dataset.type);

            })
        });

        if (this.$analyzeWithButton) {
            this.$analyzeWithButton.addEventListener("click", (e) => {
                this.analyzeBases(e)
            })
        }

        this.$changeSequenceButtons.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.changeSequence(el, e)
            })
        })

        this.$annotateAsButtons.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.annotateSequence(el, e);
            })
        })

        this.$changeSlotButtons.forEach((el) => {
            el.addEventListener("click", (e) => {
                this.slotActions(el, e)
            })
        });

        if (this.$extractButton) {
            this.$extractButton.addEventListener("click", (e) => {
                this.extractSequence(e);
            });
        }

        this.$zoom.addEventListener("input", e => {
            this.EventsTrigger("setFontWidth", (24 - e.target.value))
        })

        this.$zoom.addEventListener("keydown", function (event) {
            event.preventDefault();
            return false;
        });

        this.$zoomButtons.forEach(el => {
            el.addEventListener("click", () => {
                this.zoom += (parseInt(el.dataset.editorZoom) < 0 ? .5 : -.5);

                if (this.zoom >= 4 && this.zoom <= 20) {
                    this.EventsTrigger("setFontWidth", this.zoom)
                    this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)

                    this.$zoom.value = 24 - this.zoom
                } else {
                    this.zoom = this.zoom < 4 ? 4 : 20;
                }
            })
        })

        this.$slider.addEventListener("change", e => {
            this.offsetScroll.current = parseInt(e.target.value)
            this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
            this.EventsTrigger("slide", "end")
        })

        this.$slider.addEventListener("keydown", function (event) {
            event.preventDefault();
            return false;
        });

        this.$sliderButtons.forEach(el => {
            el.addEventListener("click", () => {
                const min = 0;
                let max = this.settings.circular ? this.sequenceLength : this.sequenceLength - this.maxBasePairsInAreaView;

                this.offsetScroll.current += parseInt(el.dataset.editorScroll);

                if (this.offsetScroll.current < min || this.offsetScroll.current > max) {
                    if (this.offsetScroll.current < min) {
                        this.offsetScroll.current = min
                    } else {
                        this.offsetScroll.current = max
                    }
                }

                this.$slider.value = this.offsetScroll.current;

                this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
                this.EventsTrigger("slide", "end")
            })
        })

        this.$selectAllButton.forEach(el => {
            el.addEventListener("click", (e) => {
                this.selectAllBasePairs();
            })
        })

        this.$reverseSelectionButton.forEach(el => {
            el.addEventListener("click", (e) => {
                this.reverseSelection();
            })
        })
    }

    /**
     * end bind toolbar events buttons
     * */

    goToInputValue(inputValue) {
        if (parseInt(this.currentValueInputs.cursorPosition) !== inputValue) {
            const basePair = inputValue - 1;

            this.activePanel = "moveTo";

            const rangeBp = {
                start: basePair,
                end: basePair
            }
            this.selectRange(rangeBp)

            if (!(this.edges.left <= rangeBp.start && rangeBp.end <= this.edges.right)) {
                const newOffsetScroll = this.settings.circular ? Math.round(rangeBp.start) : Math.round(rangeBp.start) - Math.round(this.maxBasePairsInAreaView / 2);
                this.setOffsetScroll(newOffsetScroll);
                this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
                this.EventsTrigger("slide", "end")
            }

            this.EventsTrigger("selectRange", rangeBp);
        }
    }

    analyzeWith(data) {
        const dataType = (data.for === "nucleotide") ? getBasePairs(this.sequence, data.start, data.end) : data.src
        let url = "";
        if (data.tool === "blast") {
            url += "https://blast.ncbi.nlm.nih.gov/Blast.cgi?PROGRAM=blast";
            url += (data.for === "nucleotide") ? "n" : "p";
            url += "&PAGE_TYPE=BlastSearch&BLAST_SPEC=&LINK_LOC=blasttab&LAST_PAGE=blastp&QUERY=";
        }
        window.open(url + dataType, "_blank")
    }

    copyBasePairs(data) {
        if (this.checkBaseNumber("copy")) {
            const start = Math.round(this.rangeBp.start);
            let end = Math.round(this.rangeBp.end);

            let basePairsSelected = getBasePairs(this.sequence, start, end);
            if (data === "complement") {
                basePairsSelected = basePairsSelected.split("").reverse().map(b => complementBases[b]).join("")
            }

            this.copyToClipboard(basePairsSelected);
        } else {
            return false
        }
    }

    /**
     * @param {data} String
     * */
    copyToClipboard(data) {
        const $toastContainer = document.querySelector(Selector.TOASTS);
        shortcuts.copy($toastContainer, data);
    }

    changeSequence(element, event) {
        event.preventDefault();

        const $button = event.currentTarget;
        const operation = $button.dataset.type;

        if (this.checkBaseNumber(operation)) {
            const [fromBp, toBp] = this.checkInputs(operation);

            /**
             * check if
             * range selection do not overlap multiple slots
             * range selection do not overlap start
             * */
            if (this.mainData.length === 1 && fromBp <= toBp) {

                if (operation === 'mutate-bases') {
                    const direction = $button.dataset.direction;
                    let RangeSequence = getRangeBases(fromBp - 1, toBp, this.sequence);

                    if (direction === "2") {
                        RangeSequence = RangeSequence.split("").reverse().map(b => complementBases[b]).join("")
                    }

                    this.setNeedParameters(
                        fromBp,
                        toBp,
                        "mutate",
                        RangeSequence,
                        direction)
                }


                this.setEditorUrl($button, operation)

                if (operation === "inject-bases") {
                    if (this.mainData[0].dna_sequence?.hasOwnProperty("public")) {
                        this.openModal(element);
                    } else {
                        loadModal(this.editorUrl + "?start=" + fromBp, {});
                    }
                } else {
                    this.openModal(element);
                }
            } else {
                event.preventDefault();
                appendToast(this.$toastContainer, wordings["multiple_slots"], 2);
            }
        } else {
            event.stopPropagation();
        }
    }

    annotateSequence(element, event) {
        event.preventDefault();

        const $button = event.currentTarget;
        const operation = $button.dataset.type;

        if (this.checkBaseNumber("annotate")) {
            this.checkInputs(operation);

            this.setEditorUrl($button, operation)
            this.openModal(element);

        } else {
            event.stopPropagation();
        }
    }

    analyzeBases(event, cds = null) {
        const $button = event.currentTarget;

        if (this.checkBaseNumber("analyze")) {
            const start = Math.round(parseInt(this.$baseBpFrom.value) - 1);
            const end = Math.round(parseInt(this.$baseBpTo.value))

            this.analyzeWith({
                "start": start,
                "end": end,
                "tool": $button.dataset.type,
                "for": $button.dataset.for,
                "src": cds ? getSelectedAminoAcids(cds, start, end, this.sequenceLength) : "sequence"
            })
        } else {
            return false
        }
    }

    extractSequence(event) {
        event.preventDefault();
        const $button = event.currentTarget;
        this.setEditorUrl($button, $button.dataset.type)
        this.openModal($button);
    }

    selectAllBasePairs() {
        let start = 0
        let end = this.sequenceLength;

        if (this.settings.circular) {
            start = this.rangeBp.start
            end = rangeOverlapStart(start, start, this.sequenceLength)
        }

        const newRangeBp = {
            start: Math.round(start),
            end: Math.round(end),
        }

        this.selectRange(newRangeBp)

        this.EventsTrigger("selectRange", newRangeBp);
    }

    reverseSelection() {
        const currentFromBpInput = parseInt(this.$baseBpFrom.value);
        const currentToBpInput = parseInt(this.$baseBpTo.value);

        let fromBp;
        let toBp;
        let start;
        let end;

        if (currentToBpInput < currentFromBpInput) {
            fromBp = currentToBpInput + 1;
            toBp = currentFromBpInput - 1;
            start = fromBp - 1
            end = toBp

            this.GCContent = this.getGCContent(start, end);

            this.slotsAffectedByRange(start, end);

            this.setInputValues(fromBp, toBp);
            this.setNeedParameters(fromBp, toBp, "reverse");
            this.printSummary();
        } else {
            fromBp = currentToBpInput + 1;
            toBp = currentFromBpInput;

            /**
             * check if end or start selection are in the construct's edges
             * */
            if (fromBp > this.sequenceLength) {
                fromBp = 1;
            }
            if (toBp === 1) {
                toBp = this.sequenceLength + 1
            }

            start = fromBp - 1;
            end = toBp - 1;

            this.GCContent = this.getGCContent(start, end);
            this.slotsAffectedByRange(start, end);

            this.setInputValues(fromBp, toBp - 1);
            this.setNeedParameters(fromBp, toBp - 1, "reverse");
            this.printSummary();
        }

        this.rangeBp = {
            start: start,
            end: end
        }
        this.EventsTrigger('reverseRange', this.rangeBp);
    }

    contextMenuEditorEvents() {
        const $contextMenuChangeSequenceItems = document.querySelectorAll(`${Selector.POPPER_MENU} [data-change-sequence]`);
        const $contextMenuAnnotateSequenceItems = document.querySelectorAll(`${Selector.POPPER_MENU} [data-annotate-sequence]`);
        const $contextMenuCopyBasesItems = document.querySelectorAll(`${Selector.POPPER_MENU} [data-copy-bases]`);

        const $analyzeWithButton = document.querySelector(`${Selector.POPPER_MENU} [data-analyze-with]`);
        const $extractSequence = document.querySelector(`${Selector.POPPER_MENU} [data-type=extract-sequence]`);
        const $selectAllContextMenuButton = document.querySelector(`${Selector.POPPER_MENU} [data-selection-all]`);
        const $reverseSelectContextMenuButton = document.querySelector(`${Selector.POPPER_MENU} [data-reverse-selection]`);

        $contextMenuChangeSequenceItems.forEach(el => {
            el.addEventListener('click', e => {
                if (el.hasAttribute("data-editor-url")) {
                    this.changeSequence(el, e)
                }
            })
        })

        $contextMenuAnnotateSequenceItems.forEach(el => {
            el.addEventListener('click', e => {
                this.annotateSequence(el, e);
            })
        })

        $contextMenuCopyBasesItems.forEach(el => {
            if (this.isSingleStranded && el.dataset.copyBases === "complement") {
                el.classList.add("d-none")
            }
            el.addEventListener('click', e => {
                this.copyBasePairs(e.currentTarget.dataset.type);
            })
        })

        if ($analyzeWithButton) {
            $analyzeWithButton.addEventListener('click', e => {
                this.analyzeBases(e);
            })
        }

        if ($extractSequence) {
            $extractSequence.addEventListener('click', e => {
                this.extractSequence(e)
            })
        }

        if ($selectAllContextMenuButton) {
            $selectAllContextMenuButton.addEventListener("click", () => {
                this.selectAllBasePairs();
            })
        }

        if ($reverseSelectContextMenuButton) {
            $reverseSelectContextMenuButton.addEventListener("click", () => {
                this.reverseSelection();
            })
        }
    }

    contextMenuAnnotationEvents(annotation) {
        const $ctxStandardAnnotationItems = document.querySelectorAll(`${Selector.POPPER_MENU} ${Selector.STANDARD_ANNOTATION_ITEMS}.list-group-item-action`);
        const $ctxCodingSequenceItems = document.querySelectorAll(`${Selector.POPPER_MENU}  ${Selector.CODING_SEQUENCE_ANNOTATION_ITEMS}.list-group-item-action`);
        const $ctxFragmentItems = document.querySelectorAll(`${Selector.POPPER_MENU} ${Selector.FRAGMENT_ANNOTATION_ITEMS}.list-group-item-action`);

        $ctxStandardAnnotationItems.forEach(item => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                if (item.dataset.action === "toggle") {
                    this.EventsTrigger("toggleObjects", {
                        selector: "annotations",
                        objects: [annotation.pk],
                        visible: false
                    });
                } else {
                    this.setAnnotationUrl(item, annotation);
                }
            })
        })

        if (annotation.hasOwnProperty("amino_sequence")) {
            $ctxCodingSequenceItems.forEach(item => {
                item.addEventListener("click", (e) => {
                    e.preventDefault();

                    if (item.dataset.action.startsWith("copy")) {
                        this.EventsTrigger('copyAminoAcids', {
                            cds: annotation,
                            caller: item,
                            selectedRange: item.dataset.type === "entire",
                        })
                    }

                    if (item.dataset.action === "select") {
                        const start = annotation.start;
                        let end = annotation.end;
                        this.activePanel = "range";

                        const fromBp = start + 1;
                        const toBp = end;

                        this.rangeBp = {
                            start: start,
                            end: start >= end ? end + this.sequenceLength : end
                        }

                        this.GCContent = this.getGCContent(start, end);

                        this.slotsAffectedByRange(start, end);

                        this.setInputValues(fromBp, toBp);
                        this.setNeedParameters(fromBp, toBp, "selection");
                        this.printSummary();
                        this.setPanel();

                        this.EventsTrigger('selectRange', this.rangeBp);
                    }

                    if (item.dataset.action === "analyze") {
                        this.analyzeBases(e, annotation)
                    }

                    if (item.dataset.action === "view-variants") {
                        const variant = annotation.variants.filter(a => a.index === variantPosition(annotation, Math.round(this.rangeBp.start)))
                        loadModal(`${variant[0].urls.view}`, {})
                    }

                    if (item.dataset.action === "add-variants") {
                        loadModal(`${annotation.urls.variants}`, {
                            "start": Math.round(this.rangeBp.start + 1)
                        })
                    }

                    if (item.dataset.action === "delete-variants") {
                        const variant = annotation.variants.filter(a => a.index === variantPosition(annotation, Math.round(this.rangeBp.start)))
                        loadModal(`${variant[0].urls.delete}`, {})
                    }

                    if (item.dataset.action === "mutate-bases") {
                        const direction = item.dataset.direction;
                        const [fromBp, toBp] = this.checkInputs(item.dataset.action);
                        let rangeSequence = getRangeBases(fromBp - 1, toBp, this.sequence);

                        if (direction === "2") {
                            rangeSequence = rangeSequence.split("").reverse().map(b => complementBases[b]).join("")
                        }

                        this.setNeedParameters(
                            fromBp,
                            toBp,
                            item.dataset.action,
                            rangeSequence,
                            direction)

                        this.setEditorUrl(item, item.dataset.action);
                        this.openModal(item);
                    }
                })
            })

            const $contextMenuOptimize = document.querySelectorAll(`${Selector.POPPER_MENU} a[data-action=optimize]`);
            $contextMenuOptimize.forEach(el => {
                if (this.settings.activeOptimization) {
                    el.classList.remove("disabled")
                    el.innerHTML = "Optimize"
                } else {
                    el.classList.add("disabled")
                    el.innerHTML = "Optimize (Coming Soon)"
                }

                el.addEventListener('click', e => {
                    this.openOptimizeModal(annotation)
                })
            })
        }

        if (annotation.context_type === "cloningrequest") {
            $ctxFragmentItems.forEach(item => {
                item.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (item.dataset.action === "remove") {

                        this.EventsTrigger("toggleObjects", {
                            selector: "annotations",
                            objects: [annotation.pk],
                            visible: false
                        });
                    }

                    if (item.dataset.action === "toggle-lock") {
                        this.setAnnotationUrl(item, annotation);
                    }
                })
            })
        }
    }

    openOptimizeModal(annotation) {
        this.editorUrl = "/proteins/coding-sequences/" + annotation.pk + "/optimizations/"
        let errorMessage = "You don’t have enough permission to optimize this coding sequence";

        if (this.srcData.slots?.length > 0) {
            const slots = getAffectedSlots(annotation.start, annotation.end, this.srcData.slots, this.sequenceLength);
            if (slots.length > 1) {
                errorMessage = "Currently it is not possible to optimize coding sequences spanning between multiple slots"
            }
        }
        loadModal(this.editorUrl, this.modalParameters, errorMessage);
    }

    contextMenuSlotEvents(slot) {
        const $contextMenuSlotItems = document.querySelectorAll(`${Selector.POPPER_MENU} a.needs-editing, .toolbar-slot a.slot`);

        $contextMenuSlotItems.forEach((el) => {
            if (!slot.editable) {
                el.classList.add("disabled")
            } else {
                if ((el.dataset.type === "revert-orientation" && slot.direction !== null) || el.dataset.type !== "revert-orientation") {
                    el.classList.remove("disabled")
                    el.addEventListener("click", (e) => {
                        this.slotActions(el, e)
                    })
                } else {
                    el.classList.add("disabled")
                }
            }
        });
    }

    slotActions(element, event) {
        const $button = event.currentTarget;

        if ($button.classList.contains("disabled")) {
            return false;
        }
        this.setEditorUrl(element, element.dataset.type)

        this.openModal(element);
    }

    setEditorUrl(el, operation) {
        if (el.hasAttribute("data-editor-url")) {
            if (el.dataset.editorUrl) {
                this.editorUrl = el.dataset.editorUrl;
            } else {
                this.editorUrl = editorPath(this.srcData.slots, this.mainData[0], this.rootUrl, operation)
            }
        } else {
            this.editorUrl = el.dataset.editorUrl;
        }
    }

    setAnnotationUrl(el, annotation) {
        const action = el.dataset.action === "view" ? "" : el.dataset.action;
        const path = annotationPath(annotation, action);
        loadModal(path, {});
    }

    openModal(el, errorMessage) {
        if (el.style.cursor !== 'not-allowed') {
            loadModal(this.editorUrl, this.modalParameters, errorMessage);
        }
    }

    updateInputs(fromBp, toBp, start, end, panel, operation) {
        this.activePanel = panel;

        if (panel === "moveTo") {
            this.GCContent = 0;
        } else {
            this.GCContent = this.getGCContent(start, end);
        }
        this.setInputValues(fromBp, toBp);
        this.setNeedParameters(fromBp, toBp, operation);
        this.printSummary();

        this.EventsTrigger('selectRange', {
            "start": start,
            "end": end,
        });
    }

    setScrollerInputRange(newValue) {
        this.$slider.value = newValue;
        this.areaViewSettings.pos = newValue;

        let [l, r] = getBoundsBpArea(this.areaViewSettings.pos, this.areaViewSettings.width / 2, this.sequenceLength, this.settings.circular);
        this.edges.left = l;
        this.edges.right = r;
    }

    changeBasePairInput(event) {
        event.preventDefault();
        const $input = event.currentTarget;

        if ((event.type === "click" || event.code === "Enter") &&
            this.currentValueInputs[$input.id] !== parseInt($input.value)
        ) {
            const inputValue = +$input.value;
            const inputName = $input.id;
            let fromBp, toBp;
            let start, end;

            if (this.checkBaseNumber(inputName)) {
                if (inputName === "cursorPosition") {
                    this.activePanel = "moveTo";
                    fromBp = inputValue;
                    toBp = inputValue;

                    start = fromBp - 1;
                    end = toBp - 1;
                    this.GCContent = 0;
                } else {
                    this.activePanel = "range";
                    if (inputName === "fromBp") {
                        fromBp = inputValue;
                        if (fromBp === this.sequenceLength) {
                            fromBp = 1;
                        }
                        toBp = parseInt(this.$baseBpTo.value)
                        start = fromBp - 1;
                        end = toBp;

                    } else {
                        fromBp = parseInt(this.$baseBpFrom.value);
                        toBp = inputValue
                        start = fromBp - 1;
                        end = toBp;
                    }
                    if (start === end && this.settings.circular) {
                        end += this.sequenceLength;
                    }

                    this.GCContent = this.getGCContent(start, end);

                    if (this.settings.circular && (+fromBp === (toBp + 1))) {
                        this.selectAll = true;
                        toBp += this.sequenceLength
                    }
                    start = fromBp - 1;
                    end = toBp;
                }

                this.rangeBp = {
                    start: start,
                    end: rangeOverlapStart(start, end, this.sequenceLength, start === end),
                }

                this.slotsAffectedByRange(start, end);
                this.setNeedParameters(fromBp, toBp, "selection");
                this.printSummary();

                /**
                 * check if selection (fromBp || toBp) is inside areaView
                 * */
                if (!isInsideArea(inputValue, inputValue, this.edges.left, this.edges.right, this.sequenceLength)) {
                    const newOffsetScroll = this.settings.circular ? inputValue : inputValue - Math.round(this.maxBasePairsInAreaView / 2);
                    this.setOffsetScroll(newOffsetScroll);
                    this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
                    this.EventsTrigger("slide", "end")
                }

                this.EventsTrigger("selectRange", this.rangeBp);

                this.currentValueInputs[$input.id] = parseInt($input.value);
            }
        }
    }

    search(textToSearch) {
        this.initSearch();

        if (textToSearch.length > 0) {
            const cleanedSearchText = cleanSearchText(textToSearch, this.$searchInSelectionDropDown.value === "inSequence");
            this.$txtToSearch.value = cleanedSearchText;

            if (cleanedSearchText.length) {
                this.statusSearch.textLength = cleanedSearchText.length

                this.EventsTrigger("search", {
                    "txtToSearch": cleanedSearchText,
                    "inSequence": this.$searchInSelectionDropDown.value === "inSequence",
                    "inRangeBp": this.$searchInRangeCheckBox.checked
                })
            } else {
                this.resetSearch();
                this.EventsTrigger("resetSearch")
                appendToast(this.$toastContainer, wordings["invalid_input"], 1)
            }
        }
    }

    resultSearch(data) {
        this.tempCountResultSearchRead += 1;
        this.statusSearch.results = data.result;

        if (this.statusSearch.results.length) {
            this.statusSearch.length = this.statusSearch.results.length;
            this.statusSearch.currentPosition = 0;
            this.statusSearch.results.sort((a, b) => a.pos - b.pos);

            this.moveOnSearch(this.statusSearch.currentPosition);
        } else {
            appendToast(this.$toastContainer, "no items found", 1);
        }
    }

    initSearch() {
        this.statusSearch = {
            textLength: 0,
            length: 0,
            currentPosition: -1,
            results: []
        }

        this.tempCountResultSearchRead = 0;
        this.$elementsFound.innerHTML = `0 of 0`;
    }

    resetSearch() {
        this.initSearch();

        this.$txtToSearch.value = "";

        this.setSelectionSearch("inSequence");

        this.$searchInRangeCheckBox.checked = false;
        this.$searchInRangeCheckBox.disabled = true;
    }

    setSelectionSearch(selectionInSearch) {
        this.$txtToSearch.placeholder = selectionInSearch === 'inSequence' ? 'Search in Sequence' : 'Search in Protein';
        this.$searchInSelectionDropDown.value = selectionInSearch;
    }

    moveOnSearch(position) {
        if (position >= 0 && position < this.statusSearch.length) {
            this.statusSearch.currentPosition = position
            this.$elementsFound.innerHTML = `${position + 1} of ${this.statusSearch.length}`;

            if (this.settings.circular) {
                this.offsetScroll.current = this.statusSearch.results[position].pos;
            } else {
                const min = 0;
                const max = this.sequenceLength - this.maxBasePairsInAreaView;
                this.offsetScroll.current = Math.round(this.statusSearch.results[position].pos - (this.maxBasePairsInAreaView / 2));

                if (this.offsetScroll.current < min || this.offsetScroll.current > max) {
                    if (this.offsetScroll.current < min) {
                        this.offsetScroll.current = min
                    } else {
                        this.offsetScroll.current = max
                    }
                }
            }

            const rangeBp = {
                start: this.statusSearch.results[position].pos,
                end: this.statusSearch.results[position].pos + this.statusSearch.results[position].length
            };

            this.selectRange(rangeBp, false)

            this.$slider.value = this.offsetScroll.current

            this.EventsTrigger("setOffsetScroll", this.offsetScroll.current)
            this.EventsTrigger("slide", "end")

            this.EventsTrigger("moveOnSearchResult", {
                rangeBp: rangeBp,
                id: this.statusSearch.results[position].id
            })
        } else {
            this.statusSearch.currentPosition = this.statusSearch.currentPosition ? this.statusSearch.length : -1;
        }
    }

    checkInputs(operation) {
        let fromBp;
        let toBp;
        let start;
        let end;
        let panel;

        if (operation === basesOperationLabel.insert || operation === basesOperationLabel.upload || operation === basesOperationLabel.inject) {
            panel = "moveTo";
            fromBp = parseInt(this.$baseBpCursor.value);
            toBp = parseInt(this.$baseBpCursor.value);
            end = toBp - 1;
        } else {
            panel = "range";
            fromBp = parseInt(this.$baseBpFrom.value);
            toBp = parseInt(this.$baseBpTo.value);
            end = toBp;
        }
        start = fromBp - 1;
        end = rangeOverlapStart(start, end, this.sequenceLength, start === end);
        this.updateInputs(fromBp, toBp, start, end, panel, operation);
        return [fromBp, toBp];
    }

    checkBaseNumber(operation) {
        const callToAction = [basesOperationLabel.insert, basesOperationLabel.upload, basesOperationLabel.inject, "cursorPosition"];
        const inputTypes = ["cursorPosition", "fromBp", "toBp"];
        let warningMessage = "";

        inputTypes.forEach((el) => {
            let input = document.querySelector('#' + el);
            const inputValue = parseInt(input.value);

            const minValue = parseInt(input.min);
            const maxValue = parseInt(input.max);

            if (!validInputValueEdges(inputValue, minValue, maxValue)) {
                warningMessage = "review_input";
            }
        });

        if (!warningMessage &&
            !this.settings.circular &&
            !callToAction.includes(operation) &&
            +this.$baseBpFrom.value > +this.$baseBpTo.value) {

            warningMessage = "wrong_input";
        }

        if (warningMessage !== "") {
            appendToast(this.$toastContainer, wordings[warningMessage], 1)
            return false;
        }

        return warningMessage === "";
    }

    validationInputError(message) {
        const form = document.getElementsByClassName('needs-validation');
        const $areaTxtToSearch = document.querySelector('#areaTxtToSearch');

        Array.prototype.filter.call(form, (form) => {
            if (message) {
                let inputsToValidate = form.getElementsByTagName('input');
                Array.prototype.filter.call(inputsToValidate, (inputsToValidate) => {
                    if (inputsToValidate.id === message.input) {
                        const messageErrors = (inputsToValidate.parentNode.parentNode).querySelectorAll('.invalid-feedback');
                        messageErrors.forEach((el) => {
                            el.innerHTML = message.errors.message
                            el.classList.add('d-block')
                        })
                        $areaTxtToSearch.classList.remove('pb-3');
                    }
                })
            } else {
                $areaTxtToSearch.classList.add('pb-3');
                form.querySelectorAll('.invalid-feedback').forEach((el) => {
                    el.classList.remove('d-block');
                })
            }
        });
    }

    getGCContent(start, end) {
        const tmpEnd = start >= end ? end + this.sequenceLength : end;
        const selectedBases = getRangeBases(start, tmpEnd, this.sequence);
        return ((countCharacters(selectedBases.toUpperCase(), "CG") / selectedBases.length) * 100).toFixed(2);
    }

    setScroll(data) {
        this.offsetScroll.current -= data;

        this.edges.left -= data
        this.edges.right -= data

        if (this.settings.circular) {
            if (this.edges.left < 0) {
                this.edges.left += this.sequenceLength;
            }
            if (this.edges.left > this.sequenceLength) {
                this.edges.left -= this.sequenceLength;
            }

            if (this.edges.right < 0) {
                this.edges.right += this.sequenceLength;
            }
            if (this.edges.right > this.sequenceLength) {
                this.edges.right -= this.sequenceLength;
            }

            if (this.offsetScroll.current > this.sequenceLength) {
                this.offsetScroll.current -= this.sequenceLength;
            }

            if (this.offsetScroll.current < 0) {
                this.offsetScroll.current += this.sequenceLength;
            }
        } else {
            if (this.edges.left < 0) {
                this.edges.left = 0;
                this.offsetScroll.current = 0;
            }
            if (this.edges.left > (this.sequenceLength - this.maxBasePairsInAreaView)) {
                this.edges.left = (this.sequenceLength - this.maxBasePairsInAreaView);
                this.offsetScroll.current = (this.sequenceLength - this.maxBasePairsInAreaView);
            }

            if (this.edges.right < this.maxBasePairsInAreaView) {
                this.edges.right = this.maxBasePairsInAreaView;
            }
            if (this.edges.right > this.sequenceLength) {
                this.edges.right = this.sequenceLength;
            }
        }

        this.$slider.value = this.offsetScroll.current;
    }

    setOffsetScroll(data) {
        this.offsetScroll.current = data;

        if (!this.settings.circular) {
            if ((this.offsetScroll.current + this.maxBasePairsInAreaView) > this.sequenceLength) {
                this.offsetScroll.current = this.sequenceLength - this.maxBasePairsInAreaView;
            } else if (this.offsetScroll.current < 0) {
                this.offsetScroll.current = 0;
            }
        }
        this.$slider.value = this.offsetScroll.current

        if (this.settings.circular) {
            this.edges.left = this.offsetScroll.current - Math.round(this.maxBasePairsInAreaView / 2)
            this.edges.right = this.edges.left + this.maxBasePairsInAreaView;

            if (this.edges.left < 0) {
                this.edges.left += this.sequenceLength;
            }
            if (this.edges.right > this.sequenceLength) {
                this.edges.right -= this.sequenceLength;
            }
        } else {
            this.edges.left = this.offsetScroll.current;
            this.edges.right = this.edges.left + this.maxBasePairsInAreaView;

            if (this.edges.left < 0) {
                this.edges.left = 0;
            }
            if (this.edges.right > this.sequenceLength) {
                this.edges.right = this.sequenceLength;
            }
        }
    }

    setFontWidth(data) {
        if (this.sequenceLength > this.minSequenceLength) {
            this.$zoom.value = (24 - data)
        }
    }

    newBasePair(newBasePair) {
        const path = editorPath(
            this.srcData.slots,
            this.mainData[0],
            this.rootUrl,
            "insert-bases"
        )

        loadModal(path, {
            start: Math.round(this.rangeBp.start + 1),
            sequence: newBasePair
        })
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("selectRange", "selectRange", this);

            this.mediator.on("setData", "setData", this);
            this.mediator.on("updateAnnotations", "updateAnnotations", this);

            this.mediator.on("setAreaView", "setAreaView", this);
            this.mediator.on("validationInputError", "validationInputError", this);

            this.mediator.on("selectAllBasePairs", "selectAllBasePairs", this);

            this.mediator.on("appendContextMenuEditorEvents", "contextMenuEditorEvents", this)
            this.mediator.on("appendContextMenuAnnotationEvents", "contextMenuAnnotationEvents", this)
            this.mediator.on("openOptimizeModal", "openOptimizeModal", this)
            this.mediator.on("setContextMenuSlotEvents", "contextMenuSlotEvents", this)

            this.mediator.on("setFontWidth", "setFontWidth", this);

            this.mediator.on("setScroll", "setScroll", this);
            this.mediator.on("setOffsetScroll", "setOffsetScroll", this);

            this.mediator.on("resultSearch", "resultSearch", this);
            this.mediator.on("copyBasePairs", "copyBasePairs", this)
            this.mediator.on("copyToClipboard", "copyToClipboard", this)

            this.mediator.on("newBasePair", "newBasePair", this)
        }
    }
}